import { render, staticRenderFns } from "./AlertBanner.vue?vue&type=template&id=15740b95&scoped=true"
import script from "./AlertBanner.vue?vue&type=script&lang=js"
export * from "./AlertBanner.vue?vue&type=script&lang=js"
import style0 from "./AlertBanner.vue?vue&type=style&index=0&id=15740b95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15740b95",
  null
  
)

export default component.exports